import {
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  ListItemText,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import { MuiTelInput } from "mui-tel-input";
import React from "react";
import { Controller, useForm } from "react-hook-form";
import ButtonPolicy from "../Permission/ButtonPolicy";
import { Createuser, PrepareUserData } from "src/apis/user_apis";
import { useAlertContext } from "src/hooks/use-alert";

const CreateUserForm = ({
  roles,
  open,
  setOpen,
  setOutcome,
  setadvice,
  setIsCreateUserForm,
}) => {
  const alert = useAlertContext();

  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: 150,
        width: 250,
        marginTop: 5,
      },
    },
  };

  const { control, watch, handleSubmit, reset } = useForm({
    defaultValues: {
      firstName: "",
      lastName: "",
      userName: "",
      email: "",
      password: "",
      confirmPassword: "",
      phoneNumber: "",
      address: "",
      roles: [],
    },
  });

  const formPassword = watch("password", "");
  const confirmFormPassword = watch("confirmPassword", "");

  const isFormButtonDisabled =
    formPassword === "" || formPassword !== confirmFormPassword;

  const onSubmit = (data) => {
    const selectedRoles = data.roles.map((formRole) => {
      return roles.find((role) => role.value === formRole);
    });
    data.roles = selectedRoles;
    const body = PrepareUserData(data);
    postUser(body);
  };

  const postUser = async (user) => {
    try {
      const res = await Createuser(user);
      const response = res.data.response[0];
      if (response.success === true) {
        reset();
        setOpen(false);
        setOutcome(true);
        setadvice(user.userName + "'s account has been created");
      }
      if (response.success === false) {
        if (response.success === false) {
          alert.setError((prev) => [
            ...prev,
            {
              status: true,
              message: "User Name " + response.errors.user_name,
            },
          ]);
        }
      }
    } catch (error) {
      console.log(error, "error");
    }
  };

  const handleClose = () => {
    setIsCreateUserForm(false);
    setOpen(false);
  };

  return (
    <div>
      <Dialog open={open} onClose={handleClose}>
        <div style={{ backgroundColor: "#282b30" }}>
          <DialogTitle
            style={{
              color: "white",
              display: "flex",
              justifyContent: "center",
            }}
          >
            Add New User
          </DialogTitle>
          <div className="modalContainer">
            <div className="modal">
              <DialogContent>
                <div
                  style={{
                    width: "500px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <form
                    style={{
                      display: "grid",
                      gridTemplateColumns: "repeat(2, 225px)",
                      gap: "15px",
                    }}
                  >
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <label>First Name</label>
                      <Controller
                        name="firstName"
                        control={control}
                        rules={{
                          required: "Please enter first name",
                          pattern: {
                            value: /^[A-Za-z]+$/i,
                            message: "Firstname requirements not met",
                          },
                        }}
                        render={({
                          field: { onChange, value },
                          fieldState: { error },
                        }) => (
                          <TextField
                            autoFocus
                            sx={{
                              "& .MuiOutlinedInput-root": {
                                "& > fieldset": {
                                  border: "1px solid white",
                                },
                              },
                              "& .MuiOutlinedInput-root:hover": {
                                "& > fieldset": {
                                  borderColor: "white",
                                },
                              },
                            }}
                            inputProps={{
                              style: {
                                fontSize: 14,
                                height: 30,
                                padding: "0 14px",
                                fontWeight: "bold",
                                color: "white",
                              },
                            }}
                            value={value}
                            onChange={onChange}
                            error={!!error}
                            helperText={error ? error.message : null}
                          />
                        )}
                      />
                    </div>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <label>Last Name</label>
                      <Controller
                        name="lastName"
                        control={control}
                        rules={{
                          required: "Please enter last name",
                          pattern: {
                            value: /^[A-Za-z]+$/i,
                            message: "Lastname requirements not met",
                          },
                        }}
                        render={({
                          field: { onChange, value },
                          fieldState: { error },
                        }) => (
                          <TextField
                            sx={{
                              "& .MuiOutlinedInput-root": {
                                "& > fieldset": {
                                  border: "1px solid white",
                                },
                              },
                              "& .MuiOutlinedInput-root:hover": {
                                "& > fieldset": {
                                  borderColor: "white",
                                },
                              },
                            }}
                            inputProps={{
                              style: {
                                fontSize: 14,
                                height: 30,
                                padding: "0 14px",
                                fontWeight: "bold",
                                color: "white",
                              },
                            }}
                            value={value}
                            onChange={onChange}
                            error={!!error}
                            helperText={error ? error.message : null}
                          />
                        )}
                      />
                    </div>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <label>User Name</label>
                      <Controller
                        name="userName"
                        control={control}
                        rules={{
                          required: "Please enter user name",
                          pattern: {
                            value: /^[a-zA-Z0-9]+$/i,
                            message: "Username requirements not met",
                          },
                        }}
                        render={({
                          field: { onChange, value },
                          fieldState: { error },
                        }) => (
                          <TextField
                            sx={{
                              "& .MuiOutlinedInput-root": {
                                "& > fieldset": {
                                  border: "1px solid white",
                                },
                              },
                              "& .MuiOutlinedInput-root:hover": {
                                "& > fieldset": {
                                  borderColor: "white",
                                },
                              },
                            }}
                            inputProps={{
                              style: {
                                fontSize: 14,
                                height: 30,
                                padding: "0 14px",
                                fontWeight: "bold",
                                color: "white",
                              },
                            }}
                            value={value}
                            onChange={onChange}
                            error={!!error}
                            helperText={error ? error.message : null}
                          />
                        )}
                      />
                    </div>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <label>Email</label>
                      <Controller
                        name="email"
                        control={control}
                        rules={{
                          required: "Please enter email",
                          pattern: {
                            value:
                              /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/i,
                            message: "Email requirements not met",
                          },
                        }}
                        render={({
                          field: { onChange, value },
                          fieldState: { error },
                        }) => (
                          <TextField
                            sx={{
                              "& .MuiOutlinedInput-root": {
                                "& > fieldset": {
                                  border: "1px solid white",
                                },
                              },
                              "& .MuiOutlinedInput-root:hover": {
                                "& > fieldset": {
                                  borderColor: "white",
                                },
                              },
                            }}
                            inputProps={{
                              style: {
                                fontSize: 14,
                                height: 30,
                                padding: "0 14px",
                                fontWeight: "bold",
                                color: "white",
                              },
                            }}
                            value={value}
                            onChange={onChange}
                            error={!!error}
                            helperText={error ? error.message : null}
                          />
                        )}
                      />
                    </div>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <label>Password</label>
                      <Controller
                        name="password"
                        control={control}
                        rules={{
                          required: "Please enter password",
                          validate: (value) => {
                            let requirements = [];
                            if (!/(?=.*[0-9])/.test(value)) {
                              requirements.push("at least one digit (0-9)");
                            }
                            if (!/(?=.*[a-z])/.test(value)) {
                              requirements.push(
                                "at least one lowercase letter (a-z)"
                              );
                            }
                            if (!/(?=.*[A-Z])/.test(value)) {
                              requirements.push(
                                "at least one uppercase letter (A-Z)"
                              );
                            }
                            if (!/(?=.*[!@#$%^&*])/.test(value)) {
                              requirements.push(
                                "at least one special character (!@#$%^&*)"
                              );
                            }
                            if (value.length < 9 || value.length > 20) {
                              requirements.push(
                                "between 9 and 20 characters long"
                              );
                            }
                            console.log(requirements, "password");
                            return requirements.length > 0
                              ? `Password must meet the following criteria: ${requirements.join(
                                  ", "
                                )}`
                              : undefined;
                          },
                        }}
                        render={({
                          field: { onChange, value },
                          fieldState: { error },
                        }) => (
                          <TextField
                            sx={{
                              "& .MuiOutlinedInput-root": {
                                "& > fieldset": {
                                  border: "1px solid white",
                                },
                              },
                              "& .MuiOutlinedInput-root:hover": {
                                "& > fieldset": {
                                  borderColor: "white",
                                },
                              },
                            }}
                            inputProps={{
                              style: {
                                fontSize: 14,
                                height: 30,
                                padding: "0 14px",
                                fontWeight: "bold",
                                color: "white",
                              },
                            }}
                            type="password"
                            value={value}
                            onChange={onChange}
                            error={!!error}
                            helperText={error ? error.message : null}
                          />
                        )}
                      />
                    </div>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <label>Confirm Password</label>
                      <Controller
                        name="confirmPassword"
                        control={control}
                        rules={{
                          required: "Please enter confirm password",
                          validate: (value) => {
                            let requirements = [];
                            if (!/(?=.*[0-9])/.test(value)) {
                              requirements.push("at least one digit (0-9)");
                            }
                            if (!/(?=.*[a-z])/.test(value)) {
                              requirements.push(
                                "at least one lowercase letter (a-z)"
                              );
                            }
                            if (!/(?=.*[A-Z])/.test(value)) {
                              requirements.push(
                                "at least one uppercase letter (A-Z)"
                              );
                            }
                            if (!/(?=.*[!@#$%^&*])/.test(value)) {
                              requirements.push(
                                "at least one special character (!@#$%^&*)"
                              );
                            }
                            if (value.length < 9 || value.length > 20) {
                              requirements.push(
                                "between 9 and 20 characters long"
                              );
                            }
                            console.log(requirements, "password");
                            return requirements.length > 0
                              ? `Password must meet the following criteria: ${requirements.join(
                                  ", "
                                )}`
                              : undefined;
                          },
                        }}
                        render={({
                          field: { onChange, value },
                          fieldState: { error },
                        }) => (
                          <TextField
                            sx={{
                              "& .MuiOutlinedInput-root": {
                                "& > fieldset": {
                                  border: "1px solid white",
                                },
                              },
                              "& .MuiOutlinedInput-root:hover": {
                                "& > fieldset": {
                                  borderColor: "white",
                                },
                              },
                            }}
                            inputProps={{
                              style: {
                                fontSize: 14,
                                height: 30,
                                padding: "0 14px",
                                fontWeight: "bold",
                                color: "white",
                              },
                            }}
                            type="password"
                            value={value}
                            onChange={onChange}
                            error={!!error}
                            helperText={error ? error.message : null}
                          />
                        )}
                      />
                    </div>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <label>Phone Number</label>
                      <Controller
                        name="phoneNumber"
                        control={control}
                        rules={{
                          required: "Please enter your phone number!",
                          minLength: {
                            value: 14,
                            message:
                              "Phone Number must be made out of at least 10 characters",
                          },
                          maxLength: {
                            value: 20,
                            message:
                              "Phone Number can not be longer than 10 characters",
                          },
                        }}
                        render={({
                          field: { onChange, value },
                          fieldState: { error },
                        }) => (
                          <MuiTelInput
                            sx={{
                              "& .MuiOutlinedInput-root": {
                                "& > fieldset": {
                                  border: "1px solid white",
                                },
                              },
                              "& .MuiOutlinedInput-root:hover": {
                                "& > fieldset": {
                                  borderColor: "white",
                                },
                              },
                            }}
                            defaultCountry="IT"
                            inputProps={{
                              style: {
                                fontSize: 14,
                                height: 37,
                                padding: 0,
                                fontWeight: "bold",
                                color: "white",
                              },
                            }}
                            value={value}
                            onChange={onChange}
                            error={!!error}
                            helperText={error ? error.message : null}
                          />
                        )}
                      />
                    </div>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <label>Address</label>
                      <Controller
                        name="address"
                        control={control}
                        rules={{
                          required: "Please enter address",
                          pattern: {
                            value: /^[\w\d\s,.-]+$/i,
                            message: "Address requirements not met",
                          },
                        }}
                        render={({
                          field: { onChange, value },
                          fieldState: { error },
                        }) => (
                          <TextField
                            sx={{
                              "& .MuiOutlinedInput-root": {
                                "& > fieldset": {
                                  border: "1px solid white",
                                },
                              },
                              "& .MuiOutlinedInput-root:hover": {
                                "& > fieldset": {
                                  borderColor: "white",
                                },
                              },
                            }}
                            inputProps={{
                              style: {
                                fontSize: 14,
                                height: 30,
                                padding: "0 14px",
                                fontWeight: "bold",
                                color: "white",
                              },
                            }}
                            value={value}
                            onChange={onChange}
                            error={!!error}
                            helperText={error ? error.message : null}
                          />
                        )}
                      />
                    </div>
                    <div className="inputContainer">
                      <label>Role</label>
                      <Controller
                        name="roles"
                        control={control}
                        rules={{
                          required: "Please select a role",
                        }}
                        render={({
                          field: { onChange, value },
                          fieldState: { error },
                        }) => (
                          <Select
                            sx={{
                              color: "white",
                              height: 37,
                              ".MuiOutlinedInput-notchedOutline": {
                                borderColor: "white",
                              },
                              "&:hover .MuiOutlinedInput-notchedOutline": {
                                borderColor: "white",
                              },
                              ".MuiSvgIcon-root ": {
                                fill: "white !important",
                              },
                            }}
                            multiple
                            value={value}
                            onChange={onChange}
                            error={!!error}
                            helperText={error ? error.message : null}
                            renderValue={(selected) => selected.join(", ")}
                            MenuProps={MenuProps}
                          >
                            {roles.map((role) => (
                              <MenuItem
                                key={role.id}
                                value={role.value}
                                sx={{ border: "none" }}
                              >
                                <Checkbox
                                  checked={value.includes(role.value)}
                                  name={role.value}
                                />
                                <ListItemText primary={role.value} />
                              </MenuItem>
                            ))}
                          </Select>
                        )}
                      />
                    </div>
                  </form>
                </div>
              </DialogContent>

              <div className="bottomPart" style={{ padding: "10px 0 10px 0" }}>
                <DialogActions>
                  <Grid container>
                    <Grid item xs={6} md={6}>
                      <div className="cancelButton">
                        <ButtonPolicy onClick={handleClose} variant="text">
                          Cancel
                        </ButtonPolicy>
                      </div>
                    </Grid>
                    <Grid item xs={6} md={6}>
                      <div className="addButton">
                        <ButtonPolicy
                          variant="text"
                          disabled={isFormButtonDisabled}
                          onClick={handleSubmit(onSubmit)}
                        >
                          submit
                        </ButtonPolicy>
                      </div>
                    </Grid>
                  </Grid>
                </DialogActions>
              </div>
            </div>
          </div>
        </div>
      </Dialog>
    </div>
  );
};

export default CreateUserForm;
